<template>
  <v-card>
    <v-card-title class="subtitle-1 py-2">{{ title }}</v-card-title>
    <v-list class="pt-0" style="max-height: 30vh; overflow-y: scroll" flat>
      <v-list-item-group
        v-model="model"
        multiple
        @change="change"
        color="primary"
      >
        <v-list-item v-for="(item, i) in items" :key="i" :selectable="false">
          <v-list-item-content class="py-0">
            <div class="d-flex justify-space-between">
              <span class="caption">{{ item.text }}</span>
              <span class="caption">{{ item.freq }}</span>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      model: [],
    };
  },
  props: {
    title: {
      type: String,
      default: "Filtros",
    },
    items: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Array,
      default: () => [],
    },
  },
  mounted(){
    this.model = this.selected;
  },
  methods: {
    change() {
      const appliedFilters = this.model.map((entry) => {
        return { source: "label", ...this.items[entry] };
      });
      console.log("appliedFilters", appliedFilters);
      this.$emit("filter", appliedFilters);
    },
  },
  watch: {
    selected() {
      this.model = this.selected;
    },
  },
};
</script>

<style scoped>
.v-list-item {
  min-height: 26px !important;
}
.v-list-item--active {
    color: black;
}
</style>